import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "max-w-md w-full" }
const _hoisted_3 = { class: "bg-white rounded-xl shadow-lg p-8" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-lg bg-red-50 p-3 text-red-600 text-sm text-center"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "mt-6 text-center border-t border-gray-100 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex justify-center mb-8" }, [
          _createElementVNode("img", {
            src: "/logo.webp",
            alt: "Optyfind",
            class: "h-20 w-auto"
          })
        ], -1)),
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 text-center mb-6" }, " Sign in to your account ", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleLogin && $setup.handleLogin(...args)), ["prevent"])),
          class: "space-y-4"
        }, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "email-address",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Email address", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-gray-400",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "email-address",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
                type: "email",
                autocomplete: "email",
                required: "",
                class: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm",
                placeholder: "you@example.com"
              }, null, 512), [
                [_vModelText, $setup.email]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("label", {
              for: "password",
              class: "block text-sm font-medium text-gray-700 mb-1"
            }, "Password", -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-gray-400",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  })
                ])
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
                type: "password",
                autocomplete: "current-password",
                required: "",
                class: "block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 sm:text-sm",
                placeholder: "Enter your password"
              }, null, 512), [
                [_vModelText, $setup.password]
              ])
            ])
          ]),
          ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: $setup.loading,
            class: "w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-semibold rounded-lg text-white bg-brand-600 hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 disabled:opacity-50 transition-colors"
          }, _toDisplayString($setup.loading ? 'Signing in...' : 'Sign in'), 9, _hoisted_7)
        ], 32),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/register",
            class: "text-sm font-medium text-brand-600 hover:text-brand-500"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Don't have an account? Register ")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}